exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#tender fieldset[data-v-3b1152b6]{padding:10px}.ms-data[data-v-3b1152b6]{color:#d4d3d3}.icon[data-v-3b1152b6]{height:15px;width:15px;float:left;margin-top:5px;margin-right:5px;font-size:11px}.svg[data-v-3b1152b6]{overflow:hidden;vertical-align:middle}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3b1152b6","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/contakt_as.vue
// module id = 504
// module chunks = 0